import styled, { css } from 'styled-components'

import { Typography } from '@/components/ui/typography'
import { withBorder } from '@/theme/utils'

export const CartProductItemContainer = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.space['8']};
    padding-bottom: ${withBorder(theme, 16)};
    border-bottom: ${theme.border.size['1']} solid ${theme.colors.gray400};

    &:not(:first-child) {
      padding-top: ${theme.space['16']};
    }
  `,
)

export const CartProductTopRow = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.space['8']};
  `,
)

export const ProductTitle = styled(Typography)(
  ({ theme }) => css`
    text-align: left;
    line-height: 1.5rem;
    cursor: pointer;

    &:focus-visible {
      outline: -webkit-focus-ring-color auto ${theme.border.size['1']};
    }
  `,
)

export const Controls = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    margin-left: auto;

    & > button:nth-child(2) {
      margin-left: ${theme.space['4']};
      margin-right: ${theme.space['16']};
    }
  `,
)

export const Prices = styled.span(
  () => css`
    display: flex;
    flex-direction: column;
    min-width: 5.6rem;
  `,
)

export const Count = styled.span(
  ({ theme }) => css`
    width: 2.6rem;
    min-width: 1.6rem;
    text-align: center;
    margin: ${theme.space['0']} ${theme.space['4']};
  `,
)

export const ProductDescription = styled(Typography)(
  () => css`
    line-height: normal;
  `,
)
